import React from "react";
import "./FlightDealsBanner.css";
import { motion } from "framer-motion";
import { faTags, faSuitcaseRolling, faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FlightDealsBanner = () => {
  return (
    <motion.div
      className="flight-deals-banner"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
    >
      <div className="deal-item">
        <FontAwesomeIcon icon={faPlaneDeparture} className="deal-icon" />
        <div>
          <h4>Student Discount</h4>
          <p>Enjoy 20% off with valid student ID</p>
        </div>
      </div>
      <div className="deal-separator"></div>
      <div className="deal-item">
        <FontAwesomeIcon icon={faSuitcaseRolling} className="deal-icon" />
        <div>
          <h4>Weekend Saver</h4>
          <p>Book Fri–Sun & get free lounge pass</p>
        </div>
      </div>
      <div className="deal-separator"></div>
      <div className="deal-item">
        <FontAwesomeIcon icon={faTags} className="deal-icon" />
        <div>
          <h4>Family Pack</h4>
          <p>15% off for 4+ travelers + extra baggage</p>
        </div>
      </div>
    </motion.div>
  );
};

export default FlightDealsBanner;
